import React, { useContext, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { CarouselContext } from 'pure-react-carousel';
import TranslationProvider from '../../providers/TranslationProvider';

import './UpcomingEventsSliderProgressRegion.scss';

export default function UpcomingEventsSliderProgressRegion({
  upcomingEvents,
  visibleSlides,
}) {
  const carouselContext = useContext(CarouselContext);
  const [currentSlide, setCurrentSlide] = useState(carouselContext?.state?.currentSlide);
  const [currentEvent, setCurrentEvent] = useState(upcomingEvents[carouselContext?.state?.currentSlide]);

  useEffect(() => {
    function onChange() {
      setCurrentSlide(carouselContext?.state?.currentSlide);
      setCurrentEvent(upcomingEvents[carouselContext?.state?.currentSlide]);
    }
    carouselContext.subscribe(onChange);
    return () => carouselContext.unsubscribe(onChange);
  }, [carouselContext]);

  return (
    <div className="UpcomingEventsSliderProgressRegion" aria-live="polite" role="status">
      <TranslationProvider
        translationKey="upcoming_events_slider_event_progress_title"
        translationValues={{
          eventName: currentEvent?.name, date: currentEvent?.date, time: currentEvent?.time, slideNumber: currentSlide + visibleSlides, totalSliderItems: upcomingEvents?.length,
        }}
      >
        {`${currentEvent.name}, ${moment(`${currentEvent.date} ${currentEvent.time}`).format('lll')}, item ${currentSlide + visibleSlides} of ${upcomingEvents?.length}`}
      </TranslationProvider>
    </div>
  );
}

UpcomingEventsSliderProgressRegion.propTypes = {
  upcomingEvents: PropTypes.arrayOf(PropTypes.shape({
    date: PropTypes.string,
    end_time: PropTypes.string,
    general_sale_date: PropTypes.string,
    image_preview: PropTypes.string,
    is_global_dining_access: PropTypes.bool,
    name: PropTypes.string,
    responsive_images: PropTypes.shape({
      urls: PropTypes.shape(),
      file_names: PropTypes.arrayOf(PropTypes.string),
      aspect_ratios: PropTypes.shape(),
    }),
    time: PropTypes.string,
    url_slug: PropTypes.string,
  })).isRequired,
  visibleSlides: PropTypes.string.isRequired,
};
